jQuery(document).ready(function ($) {


// function toggleHeaderClass() {
//     if (jQuery(window).scrollTop() > 90) {
//         jQuery("header .desktop-view").addClass("fix_top");
        
//         // 👇 top-bar hide
//         jQuery(".top-bar").slideUp();
        
//     } else {
//         jQuery("header .desktop-view").removeClass("fix_top");
        
//         // 👇 top-bar show
//         jQuery(".top-bar").slideDown();
//     }
// }

// // Run on scroll
// jQuery(window).on("scroll", toggleHeaderClass);

// // Run on page load
// jQuery(document).ready(function() {
//     toggleHeaderClass();
// });


(function () {

  let ticking = false;

  function applyHeaderState() {
    const scrollTop = window.scrollY;
    const header = document.querySelector(".desktop-view");
    const topBar = document.querySelector(".top-bar");

    if (!header) return;

    if (scrollTop > 90) {
      header.classList.add("fix_top");
      topBar && topBar.classList.add("hide-bar");
    } else {
      header.classList.remove("fix_top");
      topBar && topBar.classList.remove("hide-bar");
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(applyHeaderState);
      ticking = true;
    }
  }

  // scroll
  window.addEventListener("scroll", onScroll);

  // load
  document.addEventListener("DOMContentLoaded", applyHeaderState);

})();

jQuery('.nws-testimonial-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1171,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1050,
            settings: {
                dots: true,
                arrows: false,
  
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800,
            settings: {
                dots: true,
                arrows: false,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.blog-slide').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1171,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1050,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800,
            settings: {
                dots: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.nws-join-table .video-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1171,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1050,
            settings: {
                dots: true,
                arrows: false,
                 autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800,
            settings: {
                dots: true,
                arrows: false,
                 autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.about-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1171,
            settings: {
                 dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1050,
            settings: {
                 dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 800,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.origin-mob-slide').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToScroll: 1
});


function initMobileSlider() {
  if (window.innerWidth <= 768) {

    if (!$('.mob-slide-pdp').hasClass('slick-initialized')) {
      $('.mob-slide-pdp').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToScroll: 1
      });
    }

  } else {

    // Desktop pe destroy kar do
    if ($('.mob-slide-pdp').hasClass('slick-initialized')) {
      $('.mob-slide-pdp').slick('unslick');
    }

  }
}

// Initial Load
$(document).ready(function () {
  initMobileSlider();
});

// Resize handle
$(window).on('resize', function () {
  initMobileSlider();
});

$(".faq-item").click(function() {
// Toggle the answer when clicking on a question
$(this).find(".faq-answer").slideToggle(300);

// Close other answers
$(".faq-item").not(this).find(".faq-answer").slideUp(300);
});  

jQuery('.faq-list .accordion-item').click(function(){
  if( jQuery(this).hasClass('active-drop') ) {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
  } else {
      jQuery('.faq-list .accordion-item').removeClass('active-drop');
      jQuery(this).addClass('active-drop');
  }
});


});



// jQuery(document).ready(function($){

//   var $thumbs = $('.nws-cstom-prod .min-slide');
//   var $main = $('.nws-cstom-prod .big-slide');

//   $main.slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: false,
//     infinite: false,
//     speed: 800,
//     swipe: true,
//     adaptiveHeight: false,
//     draggable: true,
//     fade: false
//   });

//   $thumbs.slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: false,
//     infinite: false,
//     speed: 800,
//     swipe: false,
//     draggable: false,
//     touchMove: false,
//     accessibility: false
//   });

//   function playActiveVideo(index) {
//     $main.find('video').each(function(){
//       this.pause();
//       this.currentTime = 0;
//     });

//     var $currentSlide = $main.find('.slick-slide[data-slick-index="' + index + '"]');
//     var video = $currentSlide.find('video').get(0);

//     if (video) {
//       video.muted = true;
//       video.loop = true;
//       video.playsInline = true;

//       var playPromise = video.play();
//       if (playPromise !== undefined) {
//         playPromise.catch(function(){});
//       }
//     }
//   }

//   function setActiveThumb(index) {
//     $thumbs.find('.thumb-slide').removeClass('is-active');
//     $thumbs.find('.slick-slide[data-slick-index="' + index + '"] .thumb-slide').addClass('is-active');
//   }

//   $thumbs.on('click', '.slick-slide', function(e){
//     e.preventDefault();

//     var index = $(this).data('slick-index');
//     if (typeof index !== 'undefined') {
//       $main.slick('slickGoTo', index);
//     }
//   });

//   $main.on('afterChange', function(event, slick, currentSlide){
//     setActiveThumb(currentSlide);
//     playActiveVideo(currentSlide);
//   });

//   $main.on('init', function(event, slick){
//     setActiveThumb(0);
//     playActiveVideo(0);
//   });

//   $main.slick('setPosition');
//   $thumbs.slick('setPosition');

//   setActiveThumb(0);
//   playActiveVideo(0);
// });


jQuery(document).ready(function($){

  var $thumbs = $('.nws-cstom-prod .min-slide');
  var $main = $('.nws-cstom-prod .big-slide');

  function playActiveVideo(index) {
    $main.find('video').each(function(){
      this.pause();
      this.currentTime = 0;
    });

    var $currentSlide = $main.find('.slick-slide[data-slick-index="' + index + '"]');
    var video = $currentSlide.find('video').get(0);

    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(){});
      }
    }
  }

  $main.on('init afterChange', function(event, slick, currentSlide){
    var index = typeof currentSlide === 'undefined' ? 0 : currentSlide;
    playActiveVideo(index);
  });

  $main.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 800,
    swipe: true,
    adaptiveHeight: false,
    draggable: true,
    fade: false,
    asNavFor: '.nws-cstom-prod .min-slide'
  });

  $thumbs.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    speed: 800,
    swipe: false,
    draggable: false,
    touchMove: false,
    accessibility: false,
    focusOnSelect: false,
    asNavFor: '.nws-cstom-prod .big-slide'
  });

$thumbs.on('click', '.slick-slide', function () {
  var index = $(this).data('slick-index');

  $main.slick('slickGoTo', index);

  // Active class manage
  $thumbs.find('.slick-slide').removeClass('active-thumb');
  $(this).addClass('active-thumb');
});

});



jQuery(document).ready(function($){

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger is missing');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  $('[data-origin-section]').each(function(){

    var $section = $(this);
    var $wrap = $section.find('.origin-sticky-wrap');
    var $sticky = $section.find('.origin-sticky-inner');
    var $cards = $section.find('.origin-card');
    var $contents = $section.find('.origin-content-item');
    var total = $cards.length;

    if (!total) return;

    $section[0].style.setProperty('--origin-count', total);

    function stopAllVideos() {
      $cards.each(function(){
        var video = $(this).find('video').get(0);
        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    function playVideoByIndex(index) {
      var video = $cards.eq(index).find('video').get(0);
      if (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', 'muted');
        video.setAttribute('playsinline', 'playsinline');
        var promise = video.play();
        if (promise !== undefined) {
          promise.catch(function(){});
        }
      }
    }

    function getCardState(relative) {
      if (relative <= -3) {
        return {
          xPercent: -185,
          yPercent: 45,
          scale: 0.62,
          rotation: -18,
          opacity: 0.18,
          zIndex: 1
        };
      }

      if (relative === -2) {
        return {
          xPercent: -118,
          yPercent: 18,
          scale: 0.74,
          rotation: -14,
          opacity: 0.28,
          zIndex: 2
        };
      }

      if (relative === -1) {
        return {
          xPercent: -58,
          yPercent: 3,
          scale: 0.82,
          rotation: -10,
          opacity: 0.38,
          zIndex: 3
        };
      }

      if (relative === 0) {
        return {
          xPercent: 0,
          yPercent: -8,
          scale: 1,
          rotation: 0,
          opacity: 1,
          zIndex: 10
        };
      }

      if (relative === 1) {
        return {
          xPercent: 68,
          yPercent: 8,
          scale: 0.78,
          rotation: 12,
          opacity: 0.4,
          zIndex: 3
        };
      }

      if (relative === 2) {
        return {
          xPercent: 128,
          yPercent: 18,
          scale: 0.68,
          rotation: 16,
          opacity: 0.22,
          zIndex: 2
        };
      }

      return {
        xPercent: 185,
        yPercent: 35,
        scale: 0.58,
        rotation: 18,
        opacity: 0,
        zIndex: 1
      };
    }

    function setActive(index) {
      $cards.each(function(i){
        var $card = $(this);
        var relative = i - index;
        var state = getCardState(relative);

        $card.toggleClass('is-active', i === index);

        gsap.to($card, {
          xPercent: state.xPercent,
          yPercent: state.yPercent,
          scale: state.scale,
          rotation: state.rotation,
          opacity: state.opacity,
          zIndex: state.zIndex,
          duration: 0.7,
          ease: 'power2.out',
          overwrite: true
        });
      });

      $contents.each(function(i){
        var $content = $(this);

        if (i === index) {
          $content.addClass('is-active');
          gsap.to($content, {
            opacity: 1,
            y: 0,
            duration: 0.45,
            ease: 'power2.out'
          });
        } else {
          $content.removeClass('is-active');
          gsap.to($content, {
            opacity: 0,
            y: 24,
            duration: 0.3,
            ease: 'power2.out'
          });
        }
      });

      stopAllVideos();
      playVideoByIndex(index);
    }

    setActive(0);

    if ($(window).width() > 991) {
      ScrollTrigger.create({
        trigger: $wrap[0],
        start: 'top top',
     end: function() {
  return '+=' + (total * window.innerHeight);
},
pin: true,
      pin: $wrap[0],
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: function(self) {
          var index = Math.min(total - 1, Math.round(self.progress * (total - 1)));
          setActive(index);
        }
      });
    }

    $(window).on('load resize', function(){
      ScrollTrigger.refresh();
    });

  });

});


jQuery(document).ready(function($){

  $('.menu-drawer__menu-item').on('click', function(){

    const closeBtn = document.querySelector('.menu-drawer__close-button');

    if (closeBtn) {
      closeBtn.click(); 
    }

  });

});

// let isAddingToCart = false;

// addToCartBtn.addEventListener('click', function() {
//   isAddingToCart = true;

//   setTimeout(() => {
//     isAddingToCart = false;
//   }, 1000);
// });

// window.addEventListener('scroll', function() {
//   if (isAddingToCart) return; // STOP header logic
// });

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash) {
    var targetId = window.location.hash.substring(1);

    setTimeout(function () {
      var targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }, 700);
  }
});